<template>
  <div class="highlightContainer">
    <div class="wrap">
      <div class="wrapHead">
        <div class="wrapTitle">大会亮点</div>
        <div class="wrapEn">HIGHLIGHTS</div>
      </div>
      <a-carousel autoplay :autoplaySpeed="3000" :after-change="onChange"  effect="fade" easing="ease-in-out">
        <div v-for="(item, index) in arr" :key="index" class="wrapInfo">
          <div class="wrapInfoLeft">
            <div class="wrapInfoTitle">{{ item.title }}</div>
            <div class="wrapInfoSubTitle wrapInfoTitle">{{ item.subTitle }}</div>
            <div class="wrapInfoDetail">{{ item.info }}</div>
          </div>
          <img :src="item.Img" alt="" class="wrapImg" />
        </div>
      </a-carousel>
      <!-- <div class="banner">
        <img src="https://p4.ssl.qhimg.com/t110b9a930117986cbb19edf121.png" alt="" class="bannerItem" @click="navigateTo('https://damddos.com/')">
        <img src="https://p2.ssl.qhimg.com/t110b9a93014f90d57001243816.png" alt="" class="bannerItem" @click="navigateTo('https://www.uniontech.com/')">
        <img src="https://p1.ssl.qhimg.com/t110b9a9301bbaa93c3ca031976.png" alt="" class="bannerItem" @click="navigateTo('https://item.jd.com/10020916050888.html')">
      </div> -->
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const props = defineProps(['arr'])
const arr = props.arr || []
let imgSrc = ref(arr[0]?.Img)
const onChange = (current) => {
  imgSrc.value = arr[current]?.Img
}
function navigateTo(url) {
  window.open(url)
}
</script>

<style lang="scss" scoped>
.wrap {
  // width: 1600px;
  min-width: 1230px;
  width: 90%;
  margin: 0 auto;
  // margin-left: 92px;
  &Head {
    position: absolute;
    z-index: 200;
    left: 0;
    top: 0;
  }
  &Title {
    // margin-top: 110px;
    font-family: Source Han Sans;
    font-size: 48px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: 0px;
    color: #242933;
  }
  &En {
    margin-top: 16px;
    font-family: Source Han Sans;
    font-size: 24px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-7 */
    color: #8a9099;
  }
  &Info {
    display: flex !important;
    justify-content: space-between;
    &Left {
      margin-top: 100px;
    }
    &Title {
      font-family: Source Han Sans;
      font-size: 58px;
      font-weight: 500;
      line-height: 66px;
      letter-spacing: 0px;
      color: #242933;
      width: 697px;
    }
    &SubTitle {
      margin-top: 24px;
      width: 697px;
    }
    &Detail {
      font-family: Source Han Sans;
      font-size: 24px;
      font-weight: normal;
      line-height: 40px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      font-feature-settings: 'kern' on;
      /* Gray 中性/gray-8 */
      color: #525966;
      width: 748px;
      margin-top: 48px;
    }
  }
  &Img {
    position: relative;
    top: -107px;
    // width: 851px;
    width: 852px;
    // right: -106px;
  }
}
.banner {
  display: flex;
  justify-content: space-between;
  margin-bottom: 191px;
  &Item {
    width: 31%;
  }
}
.highlightContainer {
  background-color: #f3f3f3;
  // background-color: pink;
  padding: 110px 0 0;
}

.ant-carousel :deep(.slick-slide) {
  transition: opacity 1.5s ease-in-out !important;
  margin-top: 108px;
}
.ant-carousel :deep(.slick-dots) {
  justify-content: flex-start;
  top: 595px;
  margin-left: 0;
}
.ant-carousel :deep(.slick-dots li button) {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #dfe1e6;
}
:deep(.slick-dots li.slick-active button) {
  background-color: #525966 !important;
}
.bannerItem{
  cursor: pointer; /* 鼠标悬停时显示小手 */
}
</style>
